interface Props {
    className?: string;
}

export function ChevronLeftIcon({ className }: Props) {
    return (
        <svg className={className} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.89846 2.98424V1.92741C9.89846 1.8358 9.79318 1.78522 9.72209 1.84127L3.55881 6.65514C3.50644 6.69586 3.46407 6.74801 3.43492 6.8076C3.40578 6.86719 3.39062 6.93265 3.39062 6.99899C3.39062 7.06532 3.40578 7.13079 3.43492 7.19038C3.46407 7.24997 3.50644 7.30211 3.55881 7.34283L9.72209 12.1567C9.79455 12.2128 9.89846 12.1622 9.89846 12.0706V11.0137C9.89846 10.9467 9.86701 10.8825 9.81506 10.8415L4.89318 6.99967L9.81506 3.15651C9.86701 3.11549 9.89846 3.05123 9.89846 2.98424Z"
                fill="currentColor"
            />
        </svg>
    );
}
